import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import Button from "../../../../components/common/Button/Button";
import { useNavigate } from "react-router-dom";

const RewardRow = ({ iconClass, valueDisplay, isPending }) => {
  return (
    <div className="w-full flex justify-between items-center bg-[#F4F2F2] rounded-md self-stretch p-3 xs:p-[18px]">
      <div className="flex gap-2 xs:gap-1.5 flex-1 items-center">
        <div>
          <span
            className={`icon ${iconClass} text-primary text-sm xs:text-xl`}
          />
        </div>
        <div className="text-[#253FF6] font-bold text-sm xs:text-lg">
          {valueDisplay}
        </div>
      </div>

      <div className="w-8 xs:w-auto">
        <Lottie
          className="text-[#A0A0A0]"
          animationData={require("../../../../images/animation/double-arrow.json")}
        />
      </div>
    </div>
  );
};

const StepQuestComplete = ({
  responseAnswer,
  questDetailsData,
  referral = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNextPage = () => {
    navigate(`/quest/details/unlocked`, {
      state: {
        responseAnswer: responseAnswer,
        questDetailsData: questDetailsData,
        isReferral: referral,
      },
    });
  };

  const visibleRewards = useMemo(() => {
    const data = responseAnswer?.data;
    if (!data) return [];

    const rewards = [];

    if (data.add_token > 0) {
      rewards.push({
        id: "token",
        icon: "icon-rally-coin",
        display: `${data.add_token}`,
      });
    }

    if (data.awarded_stickers?.length > 0) {
      const stickerName = data.awarded_stickers[0]?.name || "";
      rewards.push({
        id: "sticker",
        icon: "icon-sticker",
        display: `${data.awarded_stickers.length} x ${stickerName}`,
      });
    }

    if (data.add_xp > 0) {
      rewards.push({
        id: "xp",
        icon: "icon-xp",
        display: `${data.add_xp} XP`,
      });
    }

    return rewards;
  }, [responseAnswer]);

  const screenContent = {
    title: referral
      ? t("quest.completedQuest.questCompleted")
      : t("quest.completedQuest.questCompleted"),
    subTitle: referral
      ? t("quest.referral.pendingRewards")
      : t("quest.detailMultipleChoice.rewardsEarned"),
    buttonText: referral ? t("base.next") : t("base.next"),
  };

  return (
    <div className="bg-white flex flex-col xs:gap-6 gap-3 overflow-y-auto justify-center items-center w-full py-6 px-[24px] xs:py-9 xs:px-[30px] rounded-md max-h-[calc(100vh-100px)] scrollbar-hide">
      <div className="text-[#253FF6] text-center font-[Figtree] text-base xs:text-xl font-semibold ">
        <span>{screenContent.title}</span>
      </div>

      <div className="w-[100px] xs:w-[120px]">
        <Lottie
          loop={true}
          animationData={require("../../../../images/animation/celebration.json")}
        />
      </div>

      <div className="text-[#253FF6] text-center font-[Figtree] text-base xs:text-2xl font-semibold">
        <span>{screenContent.subTitle}</span>
      </div>
      {referral && (
        <div className="text-[#333] text-sm xs:text-lg text-center">
          {t("quest.noRewards")}
        </div>
      )}

      <div className="flex w-full flex-col gap-2 xs:gap-3 justify-center items-center">
        {visibleRewards.length > 0 &&
          visibleRewards.map((reward) => (
            <RewardRow
              key={reward.id}
              iconClass={reward.icon}
              valueDisplay={reward.display}
              isPending={referral}
            />
          ))}
      </div>

      <Button
        text={screenContent.buttonText}
        className="flex-1 min-h-none mt-0 max-h-[50px] self-stretch rounded-md p-2 xs:p-3 text-white bg-[#253FF6] text-lg xs:text-xl font-medium text-center"
        variant="primary"
        onClick={handleNextPage}
      />
    </div>
  );
};

export default StepQuestComplete;
